import { useRef } from 'react'

import useClickOut from '../../../../hooks/useClickOut'
import styles from './MultiSelect.module.scss'

const MultiSelect = ({ options, labels, handleChange, handleClose }) => {
  const node = useRef()
  useClickOut(node, handleClose)

  return (
    <div ref={node} className={styles.dropdown}>
      {Object.keys(options).map(k => (
        <Option
          handleChange={handleChange}
          val={k}
          checked={options[k]}
          key={k}
          text={labels[k]}
        />
      ))}
    </div>
  )
}

const Option = ({ handleChange, val, checked, text }) => (
  <label className={styles.option}>
    <input type="checkbox" checked={checked} value={val} onChange={handleChange} />
    <div className={styles.label}>{text}</div>
  </label>
)

export default MultiSelect
